import getMeta from '@atlassian/jira-get-meta';
import { isFedRamp } from '@atlassian/atl-context';

export const getAdditionalAttributes = (): {
	shard: string | null;
	region: string | null;
	isFedRamp: boolean;
} => {
	const shard = getMeta('ajs-shard');
	const region = getMeta('ajs-region');

	return {
		shard,
		region,
		isFedRamp: isFedRamp(),
	};
};
